<app-dialog-header
  [header]="'library.user_card.dialog.send_alert.header' | translate"
  iconClass="icon-send-alert-msg-device-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid p-align-center">
    <div class="p-col-12">
      <label
        for="enable-lost-mode-message"
        class="send-alarm-label"
      >
        {{ 'library.user_card.dialog.send_alert.label' | translate }}:
      </label>
      <textarea
        id="enable-lost-mode-message"
        [appSuggestions]="['USER', 'ACTIVE_DIRECTORY', 'DEVICE']"
        appInput
        formControlName="message"
        rows="8"
      >
      </textarea>
      <app-input-length-counter
        [count]="form?.get('message').value.length"
        [maxLength]="MAX_MESSAGE_LENGTH"
      ></app-input-length-counter>
      <app-form-control-error [control]="form.get('message')"></app-form-control-error>
    </div>
    <div class="p-col-12">
      <app-checkbox
        [label]="'library.user_card.dialog.send_message.vibrate' | translate"
        binary="true"
        data-qa="vibrate"
        formControlName="vibrate"
      >
      </app-checkbox>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="send-message-dialog-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [submitButton]="form"
    (click)="submit(form)"
    data-qa="send-message-dialog-submit-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.send.label' | translate }}
  </button>
</div>
